<script setup>
import { ref } from 'vue';
import { SMILE_REPORT_LIST } from '@/common/constants/ConstCode';
import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const emits = defineEmits(['close']);

const reason = ref('악의적이고 부적절한 내용이에요'); // 신고 사유

const fnReport = async () => {
  // 신고 로직 구현
  if (
    await store.dispatch('smile/reportPlace', {
      reason: reason.value,
      file: props.data.file
    })
  ) {
    showTextModal('신고가 접수되었습니다.', '확인', () => {
      store.dispatch('layout/removeAllModalComponent');
    });
  } else {
    showTextModal('신고 접수에 실패했습니다.', '확인', () => {
      store.dispatch('layout/removeAllModalComponent');
    });
  }
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="check-box">
              <label class="checkbox-s" v-for="(item, index) in SMILE_REPORT_LIST" :key="index">
                <input type="radio" name="radio" :value="item.value" v-model="reason" />
                <span class="check-txt">{{ item.value }}</span>
              </label>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn border-gray medium" @click="$emit('close')">닫기</button>
              <button class="btn primary medium" @click="fnReport">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
